import { inject } from '@angular/core';
import { CanMatchFn, Route, UrlSegment } from '@angular/router';
import { AuthStatus } from '@shared/models/auth/auth.model';
import { AuthService } from '../services/auth.service';

const OBJECT_ID = /^[0-9a-f]{24}$/i;

/**
 * Convite público por link: `/oportunidades/:cardId` (a URL que o bot de WhatsApp
 * divulga nos grupos) aberto por quem NÃO tem sessão casa com a página pública de
 * convite — teaser + login/cadastro na mesma tela — em vez de cair no AuthGuard
 * → /inicio. Com sessão válida (ou tokens renováveis) a rota não casa e a mesma
 * URL segue para o detalhe autenticado; é isso que faz o "volta direto para a
 * oportunidade" após o login/cadastro (`navigateByUrl` para a mesma URL).
 *
 * Só casa `oportunidades/<ObjectId>` — `/oportunidades/buscar|minhas|disponibilidade`
 * continuam exigindo login como sempre.
 */
export const oportunidadeConvitePublicoCanMatch: CanMatchFn = (_route: Route, segments: UrlSegment[]) => {
  if (segments.length !== 2 || !OBJECT_ID.test(segments[1]?.path ?? '')) return false;
  return inject(AuthService).isAuthenticated() === AuthStatus.ALL_TOKENS_INVALID;
};
